import { render, staticRenderFns } from "./typeattribute.vue?vue&type=template&id=4dd9dddc&"
import script from "./typeattribute.vue?vue&type=script&lang=js&"
export * from "./typeattribute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports